import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const ATL_TZ = "America/New_York";
export const atl = (v) => dayjs(v).tz(ATL_TZ);

export const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n ?? 0);

export const fmtDateTime = (iso) => `${atl(iso).format("ddd, MMM D · h:mm A")} ET`;
export const fmtLongDay = (iso) => atl(iso).format("dddd, MMMM D");
export const fmtTime = (iso) => `${atl(iso).format("h:mm A")} ET`;

export const PAYMENT_LABELS = { paypal: "PayPal", cashapp: "Cash App" };

export const fareLabel = (b) => (b.fare == null ? "Custom quote" : b.quote_status === "pending" ? `From ${money(b.fare)}` : money(b.fare));

export const shortAddress = (address = "") => address.split(",").slice(0, 2).join(",");

export const initials = (name = "") =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0].toUpperCase())
    .join("");

export const isUpcoming = (b) => b.status === "confirmed" && dayjs(b.scheduled_at).isAfter(dayjs());

export function greeting() {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 18) return "Good afternoon";
  return "Good evening";
}
